<section class="about-teacher">
  <div class="container">
    <header class="about-head">
      <h2 class="about-head__title">{{ (demo.enabled ? "ABOUT_US.TEACHER.TITLE" : "ABOUT_US.TEACHER.TITLE_DEFAULT") | translate }}</h2>
    </header>

    <div class="about-card">
      <div class="about-card__grid">
        <div class="about-card__body">
          <!-- The nickname used to be appended in brackets after the name, one
               line under a heading that already says "ในระบบสาธิต". Same words
               three times on one screen. -->
          <h3 class="about-card__name">
            {{ "ABOUT_US.TEACHER.FULLNAME" | translate }}
          </h3>

          @for (group of teacherDescription; track group.title) {
            <div class="about-group">
              <!-- Underlined headings read as broken links. A weighted label
                   with a rule under it does the same job and looks deliberate. -->
              <h4 class="about-group__title">{{ group.title }}</h4>
              <ul class="about-list">
                @for (line of group.content; track line) {
                  <li>{{ line }}</li>
                }
              </ul>
            </div>
          }
        </div>

        <figure class="about-card__media">
          <img
            src="./assets/media/landing/about-teaching.webp"
            alt="ห้องเรียนตัวอย่าง"
            loading="lazy"
          />
        </figure>
      </div>

      @for (block of teacherSpecializations; track block.title) {
        <!-- Inside the card's padding, not spilling past it: this panel was a
             bare div in a .row, so the row's gutters pulled it wider than the
             text above it by half a gutter on each side. -->
        <div class="about-audience">
          <h3 class="about-audience__title">{{ block.title }}</h3>
          <ul class="about-audience__list">
            @for (line of block.content; track line) {
              <li>{{ line }}</li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
</section>
